export default __webpack_public_path__ + "static/media/tennesseeTitans@2x.83eb9f5a.jpg";